import { Component, Inject, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GraphQLError } from "graphql";
import {
    AddProjectPaymentPlanGQL,
    EditProjectPaymentPlanGQL,
    GetMasterPaymentPlanListGQL,
    GetPurchaserPaymentPlanByIdGQL,
    TypePaymentPlanEnum
} from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";
import * as moment from "moment";

export enum FormRequestType {
    EDIT = "edit",
    ADD = "create"
}

export class IntegrationTypeEnum {
    NET = "DOTNET"
    PPLUS = "PPLUS"
}


export interface DialogData {
    type: string;
    projectId: string;
    paymentPlanType: string;
    projectPaymentPlanId: string;
    effectiveDate: Date;
    expiredDate: Date;
}

@Component({
    selector: "assign-payment-plan-dialog",
    templateUrl: "assign-payment-plan-dialog.html",
})
export class AssignPaymentPlanDialog{
    result: DialogData = {
        type: "",
        projectId: "",
        paymentPlanType: "",
        projectPaymentPlanId: null,
        effectiveDate: null,
        expiredDate: null,
    };
    paymentPlanOption: any;
    projectId: string;
    formType: string;
    formGrp: FormGroup;
    formTypeRequest = FormRequestType;
    projectIntegratedType: string | undefined = undefined;
    integrationType = new IntegrationTypeEnum();

    constructor(
        private AddProjectPaymentPlanGQL: AddProjectPaymentPlanGQL,
        private EditProjectPaymentPlanGQL: EditProjectPaymentPlanGQL,
        private GetMasterPaymentPlanListGQL: GetMasterPaymentPlanListGQL,
        private GetPurchaserPaymentPlanByIdGQL: GetPurchaserPaymentPlanByIdGQL,
        private snackBarService: SnackBarService,
        public dialogRef: MatDialogRef<AssignPaymentPlanDialog>,
        @Inject(MAT_DIALOG_DATA) private data: DialogData
    ) {
        this.formType = data.type
        console.log({data})
        this.initFormGroup(data);
        if (data.type == this.formTypeRequest.ADD) this.getPaymentPlanOptions();
        this.patchForm(data);
    }

    private initFormGroup(data) {
        if (data.type == this.formTypeRequest.EDIT) {
            this.formGrp = new FormGroup({
                paymentPlanId: new FormControl({ value: "", disabled: true }),
                effectiveDate: new FormControl("", [Validators.required]),
                expiredDate: new FormControl("", [Validators.required]),
            });
        } else {
            this.formGrp = new FormGroup({
                paymentPlanId: new FormControl("", [Validators.required]),
                effectiveDate: new FormControl("", [Validators.required]),
                expiredDate: new FormControl("", [Validators.required]),
            });
        }
    }    

    private getPaymentPlanOptions() {
        this.GetMasterPaymentPlanListGQL.fetch({ projectId: this.data.projectId }).subscribe(
            (result) => {
                if (result?.errors) {
                    this.snackBarService.showQueryError(result.errors);
                }
                this.paymentPlanOption = result.data.getMasterPaymentPlanList;
                // this.projectIntegratedType = result.data.getAssignDiscountFormSource?.integrationType;
            }
        );
    }

    patchForm(data) {
        if (data.type == this.formTypeRequest.ADD) return;
        this.GetPurchaserPaymentPlanByIdGQL.fetch({
            id: data.projectPaymentPlanId,
            // projectId: data.projectId,
            typePaymentPlan : this.data?.paymentPlanType as TypePaymentPlanEnum
        }).subscribe(
            (result) => {

                if (result?.errors) return this.snackBarService.showQueryError(result.errors);

                let projectPaymentPlan = result.data.getPurchaserPaymentPlanById;
                this.paymentPlanOption = [result.data.getPurchaserPaymentPlanById];

                this.formGrp.controls.paymentPlanId.setValue(
                    projectPaymentPlan.id
                );
                this.formGrp.controls.effectiveDate.setValue(
                    projectPaymentPlan.startDate
                );
                this.formGrp.controls.expiredDate.setValue(
                    projectPaymentPlan.endDate
                );
            }
        );
    }

    // patchIntegrateSystemDate(index: number) {
    //     if (this.projectIntegratedType != this.integrationType.NET) return;
    //     let integrationDiscount = this.discountOptions[index].discountIntegration;
    //     this.formGrp.controls.effectiveDate.setValue(integrationDiscount.effectiveDate);
    //     this.formGrp.controls.expiredDate.setValue(integrationDiscount.expiredDate);
    //     this.formGrp.controls.effectiveDate.disable();
    //     this.formGrp.controls.expiredDate.disable();
    // }


    onSubmit() {
        this.formGrp.markAllAsTouched();
        const effectiveDate = moment(this.formGrp.controls.effectiveDate.value)
        const expiredDate = moment(this.formGrp.controls.expiredDate.value)

        if (expiredDate <= effectiveDate) {
            this.snackBarService.show(
                "Please Select Valid Dates."
            );
        }
        else if (this.formGrp.valid) {

            let expired_date = new Date(moment(this.formGrp.controls.expiredDate.value).format("YYYY-MMM-DD"));

            if (this.data.type == "create") {
                this.AddProjectPaymentPlanGQL.mutate({
                    input: {
                        projectId: this.data.projectId,
                        paymentPlanId: this.formGrp.controls.paymentPlanId.value,
                        startDate: this.formGrp.controls.effectiveDate.value,
                        endDate: expired_date,
                        typePaymentPlan: this.data.paymentPlanType as TypePaymentPlanEnum,
                        defaulted: false
                    },
                }).subscribe((result) => {
                    this.snackBarService.show("Record assigned successfully");
                    this.dialogRef.close();
                }, (err: GraphQLError) => {
                    this.snackBarService.show(err.message.split("Error:")[1]);
                });
            } 
            else {
                this.EditProjectPaymentPlanGQL.mutate({
                    input: {
                        id: this.data.projectPaymentPlanId,
                        paymentPlanId: this.formGrp.controls.paymentPlanId.value,
                        startDate: this.formGrp.controls.effectiveDate.value,
                        endDate: expired_date,
                        defaulted: false,
                        typePaymentPlan: this.data.paymentPlanType as TypePaymentPlanEnum,
                        projectId: this.data.projectId
                    },
                }).subscribe((result) => {
                    this.snackBarService.show("Edited Successfully");
                    this.dialogRef.close();
                }, (err: GraphQLError) => {
                    this.snackBarService.show(err.message.split("Error:")[1]);
                });
            }
        } else {
            this.snackBarService.show(
                "Please complete or correct the required field(s)."
            );
        }
    }
}
